/* eslint-disable no-console */
import { takeLatest, put } from 'redux-saga/effects';
import * as TypeActions from '../store/subNsmp/actionsTypes';
import * as NsmpTypeActions from '../store/nsmp/actionsTypes';
import BaseService from '../services/BaseService';
import FileService from '../services/FileService';
import * as ToastTypeActions from '../store/toast/actionsTypes';
import * as LoaderTypeActions from '../store/loader/actionsTypes';

function* validateInvalidateSubNsmp({ id, validateType, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    yield BaseService.patch({ url: `sub-nsmps/${id}/validate/${validateType}` });
    yield put({
      type: NsmpTypeActions.NSMPS_SUBNSMP_VALIDATE_SUCCESS,
      subNsmpId: id,
      validateType,
    });
    yield callback();
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao carregar as informações!'
    });
  }
}

function* clone({ id, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    
    const { data: subNsmpData } = yield BaseService.post({ url: `sub-nsmps/${id}/clone` });
    let arquivos = [];
    if (subNsmpData && subNsmpData.arquivos && subNsmpData.arquivos.length > 0) {
      arquivos = yield FileService.downloadArquivos(subNsmpData.arquivos, false);
    }

    yield callback({ ...subNsmpData, arquivos });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Ocorrência clonada com sucesso!'
    })
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao clonar a nsmp!'
    });
  }
}

function* deleteCloneById({ id, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.delete({ url: `sub-nsmps/clone/${id}`});
    yield callback(response.data);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Informações removidas com sucesso!'
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao remover as informações!'
    });
  }
}

export default function* watchAuth() {
  yield takeLatest(TypeActions.SUBNSMPS_UPDATE_VALIDATE, validateInvalidateSubNsmp);
  yield takeLatest(TypeActions.SUBNSMPS_CLONE, clone);
  yield takeLatest(TypeActions.SUBNSMPS_DELETE_CLONE, deleteCloneById);
}